import { render, staticRenderFns } from "./HeaderRecapSottoscrizioniPaziente.vue?vue&type=template&id=c33d07e8&scoped=true"
import script from "./HeaderRecapSottoscrizioniPaziente.vue?vue&type=script&lang=js"
export * from "./HeaderRecapSottoscrizioniPaziente.vue?vue&type=script&lang=js"
import style0 from "./HeaderRecapSottoscrizioniPaziente.vue?vue&type=style&index=0&id=c33d07e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33d07e8",
  null
  
)

export default component.exports